import React from 'react';
import GateForceSignatureD3 from '../../components/coach/charts/gate-force-graph/GateForceSignatureD3';

interface GateForcePrototypePageProps {
  sessionId: string | null;
}

const GateForcePrototypePage: React.FC<GateForcePrototypePageProps> = ({ sessionId }) => {
  return <GateForceSignatureD3 sessionId={sessionId} />;
};

export default GateForcePrototypePage;
